module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/klarna-2b5cea09a74daf5d3e172c3add5fb099.svg";